<template>
  <div class="quality">
    <div class="pc">
      <div class="banner">
        <img src="img/zbj.png" alt="" />
        <div class="mask">
          <div class="box">Quality Assurance</div>
        </div>
      </div>
      <div class="content">
        <h2>Quality Assurance</h2>
        <p>
          Kenta is primarily focused on Quallity, no matter what the service is
          , we undertake our <br />
          operations to interrational standards and acoreditation.
        </p>
        <div class="box">
          <div>
            <div class="top"><img src="img/b1.png" alt="" /></div>
            <div class="line"></div>
            <div class="module1">
              Kenta holds lso 9001 Quality <br />
              Management.The lso 9001 <br />
              family addresses various <br />
              aspects of quality
              <br />
              management and contains <br />
              some of ISo's best known <br />
              standards.
            </div>
          </div>
          <div>
            <div class="top"><img src="img/b2.png" alt="" /></div>
            <div class="line"></div>
            <div class="module1">
              Kenta holds lSO 14001. <br />
              Environment Management.The <br />
              ISO 14001 family of standards <br />
              provides practical tools for <br />
              companies and organizations <br />
              of all kinds looking to manage <br />
              their environmental
              <br />
              responsibilities.
            </div>
          </div>

          <div>
            <div class="top"><img src="" alt="" /></div>
            <div class="line"></div>
            <div class="module1">
              Kenta holds and follows <br />
              ISO/IATF 16949, this is an <br />
              internationally recognized <br />
              Quality Management System <br />
              specification for the <br />
              automotive industry.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="yd"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sw: false,
    };
  },
};
</script>

<style lang="less" scoped>
.pc {
  .banner {
    height: 29vw;
    overflow: hidden;
    text-align: center;
    position: relative;
    img {
      width: 120%;
      position: relative;
      top: -15vw;
      left: -15vw;
      z-index: 0;
    }
    .mask {
      position: absolute;
      top: 0;
      background: rgba(15, 15, 15, 0.301);
      width: 100%;
      height: 100%;
      .box {
        position: absolute;
        bottom: 0;
        width: 50%;
        height: 15%;
        left: 0;
        top: 0;
        right: 0;
        margin: auto;
        color: white;
        font-size: 4vw;
        font-weight: 800;
      }
    }
  }
  .content {
    width: 70%;
    margin: auto;
    > h2 {
      margin: 4vw 0;
      font-size: 2vw;
    }
    > p {
      font-size: 1.5vw;
    }
    .box {
      display: flex;
      margin: 5vw 0;
      background: white;
      width: 100%;
      height: 30vw;
      display: flex;
      justify-content: space-between;
      > div {
        width: 33%;
        font-size: 1vw;
        box-sizing: border-box;
        padding: 1vw;
        color: gray;
        .top {
          height: 20%;
          img {
            width: 50%;
            position: relative;
            left: -1vw;
          }
        }
        .line {
          width: 5vw;
          height: 0.15vw;
          background: red;
          margin: 1vw 0;
        }
      }
    }
  }
}
</style>